import { createInvalidStateError } from '../factories/invalid-state-error';
import { CONTEXT_STORE } from '../globals';
export const getNativeAudioContext = (audioContext) => {
    const nativeContext = CONTEXT_STORE.get(audioContext);
    if (nativeContext === undefined) {
        throw createInvalidStateError();
    }
    return nativeContext;
};
//# sourceMappingURL=/build/es2018/helpers/get-native-audio-context.js.map